import * as Yup from "yup";
import checkout from "./form3";

const {
  formField3: {
    taxAlternatePayerName,
    taxAlternatePayerId
  },
} = checkout;

const validation3 = Yup.object().shape({
  [taxAlternatePayerId.name]: Yup.string()
  .matches(/^\d{10}(?:-\d{3})?$/, taxAlternatePayerId.invalidMsg)
  .required(taxAlternatePayerId.errorMsg),
  [taxAlternatePayerName.name]: Yup.string().required(taxAlternatePayerName.errorMsg),
});

export default validation3;
